import { ListingEditModalForm } from "./ListingEditModalForm";

const ListingEditModalFormWrapper = ({
  selectedListingId,
  setSelectedListingId,
  openEditListing,
  setOpenEditListing,
  listing,
  getListing,
  exceptions,
  getExceptions
}) => {
  const itemIdForUpdate = null;
  const isLoading = false;

  if (selectedListingId) {
    return (
      <ListingEditModalForm
        isUserLoading={isLoading}
        user={{ id: undefined }}
        setSelectedListingId={setSelectedListingId}
        selectedListingId={selectedListingId}
        openEditListing={openEditListing}
        setOpenEditListing={setOpenEditListing}
        listing={listing}
        getListing={getListing}
        exceptions={exceptions}
        getExceptions={getExceptions}
      />
    );
  }
  return null;
};

export { ListingEditModalFormWrapper };
